import React from 'react'

const Manual_invukds_configuraciones_general = () => {
    return (
      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
          <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
            InvuKDS Configuraciones - General
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Esta guía proporciona instrucciones esenciales para configurar la estación InvuKDS, garantizando
            que los usuarios puedan ajustar el nombre de la licencia y los tiempos de advertencia,
            gestionando visualmente la disponibilidad del servicio y los retrasos mediante cambios de color.
          </p>
          <iframe
            src="https://scribehow.com/embed/InvuKDS_Configuraciones__General__vADgALCmToqS_67_WC_-LA?as=scrollable"
            className="scribe-iframe-general-10"
            width="100%"
            height="4300"
            allowFullScreen
            style={{ border: 0, minHeight: '640px' }}
          ></iframe>
        </div>
      </div>
    )
  }
  
  export default Manual_invukds_configuraciones_general